// Hook para gestionar el tema (light/dark/system)
// Aplica/remueve la clase .dark en <html> según la preferencia del usuario
import { useEffect } from 'react';
import { useUIStore } from '../stores/uiStore';

export function useTheme() {
  const theme = useUIStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;

    function applyTheme(resolved: 'light' | 'dark') {
      root.classList.toggle('dark', resolved === 'dark');
    }

    if (theme === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      applyTheme(mq.matches ? 'dark' : 'light');

      const handler = (e: MediaQueryListEvent) => applyTheme(e.matches ? 'dark' : 'light');
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }

    applyTheme(theme);
  }, [theme]);
}
